import { Component, OnInit } from '@angular/core';
import { ContenidoService } from '../contenido.service';

@Component({
  selector: 'app-az-loyalty',
  templateUrl: './az-loyalty.component.html',
  styleUrls: [
	'../../assets/css/bootstrap.min.css',
	'../../assets/scss/styles.scss', 
	'../../assets/scss/azamara.scss',
	'../../assets/scss/azamara-l.scss',
	'../../assets/scss/fonts.scss',
	'./az-loyalty.component.css',
	'../../assets/cssDali/general.scss'
	]
})
export class AzLoyaltyComponent implements OnInit {
  public contenido = this.contenidoService.getContenido("az-loyalty");
  constructor(private contenidoService: ContenidoService) {}

  ngOnInit() {
  }

}
